import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendEventSaveContainer from '../../../containers/recommend/event/RecommendEventSaveContainer';
import { recommendEventActions } from '../../../store/modules/recommend/event';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_EVENT_SAVE_MODEL,
} from '../../../store/modules/recommend/event/models';
import { RECOMMEND_EVENT_PAGE_NAME } from '../../../constants/service/app/recommendEventConstants';

class RecommendEventCreate extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendEventSave'],
      value: RECOMMEND_EVENT_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { prepareCreateRecommendEvent } = this.props;

    prepareCreateRecommendEvent({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_EVENT_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_EVENT_PAGE_NAME.RECOMMEND_EVENT_CREATE}>
        <RecommendEventSaveContainer />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendEventActions.setData,
  prepareCreateRecommendEvent: recommendEventActions.prepareCreateRecommendEvent,
};

export default connect(null, mapDispatchToProps)(RecommendEventCreate);
